export default class ContentCollection {
  constructor() {
    this.items = []
  }
}
